import React, { useContext } from "react";
import { breakpoints, colors } from "definitions";
import styled from 'styled-components';
import Sadosky from "icons/logos/Sadosky";
import { SiteConfigContext } from "contexts/SiteConfigContext";
import { CompetitionContext } from "contexts/CompetitionContext";
import { DEFAULT_HOME_VIDEO_URL } from "config/site";
import { getYoutubeVideoId } from "helpers";

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

// El hero mide 100vh, así que el iframe se dimensiona con la técnica de
// "background video": 16:9 centrado en absoluto y con mínimos que garantizan que
// siempre cubra el alto completo de la pantalla (el excedente lo recorta el
// overflow:hidden del Container). Esto además deja el chrome de YouTube (título y
// "More videos") fuera del área visible.
const StyledIframe = styled.iframe`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 0;
  width: 100vw;
  height: 56.25vw;
  min-height: 100vh;
  min-width: 177.78vh;
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;

`;

// El texto del hero se arma en HTML (antes venía quemado en hero_image.webp) para
// poder editar fecha y sede desde `config/site.js` o desde Firestore.
const HeroContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2.5rem;
  padding: 0 2rem;
  pointer-events: none;

  ${breakpoints.tablet} {
    /* En mobile el video es un short vertical: el texto sube para no taparlo. */
    position: absolute;
    top: 18%;
    gap: 1.5rem;
  }
`;

const Logo = styled.div`
  svg {
    width: 56rem;
    height: auto;
    display: block;
  }

  ${breakpoints.tablet} {
    svg {
      width: 100%;
      max-width: 32rem;
    }
  }
`;

const EventDate = styled.p`
  margin: 0;
  color: ${colors.fonts.white};
  font-size: 2.4rem;
  font-weight: 700;
  line-height: 2.9rem;
  letter-spacing: 0.2rem;
  text-align: center;
  text-transform: uppercase;

  ${breakpoints.tablet} {
    font-size: 1.8rem;
    line-height: 2.2rem;
    letter-spacing: 0.1rem;
  }
`;

const EventVenue = styled.span`
  color: ${colors.fonts.white};
  border: 1px solid ${colors.fonts.white};
  padding: 0.8rem 1.6rem;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 1.7rem;
  letter-spacing: 0.15rem;
  text-align: center;
  text-transform: uppercase;

  ${breakpoints.tablet} {
    font-size: 1.1rem;
    line-height: 1.4rem;
    letter-spacing: 0.1rem;
    padding: 0.6rem 1.2rem;
  }
`;

// El video se reproduce en loop con la técnica del `playlist`: sin ese
// parámetro YouTube ignora `loop=1` en un embed de un solo video.
const buildEmbedUrl = (videoId) =>
  `https://www.youtube.com/embed/${videoId}?rel=0&autoplay=1&controls=0&mute=1&loop=1&playlist=${videoId}`;

const MainVideo = () => {
  const { event } = useContext(SiteConfigContext);
  const { currentCompetition } = useContext(CompetitionContext);

  // El video sale de la competición del año en curso; si todavía no se cargó,
  // no es un link de YouTube válido o no hay competición, se usa el default.
  const videoId =
    getYoutubeVideoId(currentCompetition && currentCompetition.videoUrl) ||
    getYoutubeVideoId(DEFAULT_HOME_VIDEO_URL);

  return (
    <Container>
      <StyledIframe
        key={videoId}
        src={buildEmbedUrl(videoId)}
        frameBorder="0"
        allow="autoplay; encrypted-media"
        allowFullScreen
      ></StyledIframe>
      <Overlay>
        <HeroContent>
          <Logo>
            <Sadosky position="overlay" />
          </Logo>
          {event.date && <EventDate>{event.date}</EventDate>}
          {event.venue && <EventVenue>{event.venue}</EventVenue>}
        </HeroContent>
      </Overlay>


    </Container>
  );
};

export default MainVideo;
